"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCallCenterAPI = void 0;
var constants_1 = require("./constants");
var app_1 = require("./types/app");
var utils_1 = require("./utils");
var createCallCenterAPI = function createCallCenterAPI(options) {
    var host = options.host, path = options.path, client = options.client, phone = options.phone, sourceID = options.sourceID;
    var urls = __assign(__assign({}, constants_1.callCenterUrls), options.urls);
    var apiPath = function (apiPath) { return host + "/" + path + "/" + apiPath; };
    var withSourceID = function (requestBody) { return (__assign({ sourceid: sourceID }, requestBody)); };
    var withHeaders = function (requestHeaders) { return (__assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, requestHeaders)); };
    var withAsync = function (url, mergeOptions) {
        if (mergeOptions === void 0) { mergeOptions = {}; }
        var _a = mergeOptions.mergeBody, mergeBody = _a === void 0 ? withSourceID : _a, _b = mergeOptions.mergeHeaders, mergeHeaders = _b === void 0 ? withHeaders : _b;
        return function (asyncOptions) {
            if (asyncOptions === void 0) { asyncOptions = {}; }
            var headers = mergeHeaders(asyncOptions.headers);
            var body = mergeBody(asyncOptions.body);
            var method = asyncOptions.method || app_1.AsyncMethod.POST;
            return client({
                url: url,
                body: body,
                method: method,
                headers: headers,
                onSuccess: asyncOptions.onSuccess,
                onError: asyncOptions.onError,
            });
        };
    };
    var profileRequest = withAsync(apiPath(urls.profile), {
        mergeBody: function () { return withSourceID({
            user: {
                phone: phone,
            },
        }); },
    });
    return function fetchProfile(options) {
        var onSuccess = options.onSuccess, _a = options.onError, onError = _a === void 0 ? utils_1.noop : _a;
        var userID;
        var api = {
            __request: withAsync,
            estimate: withAsync(apiPath(urls.estimate), {
                mergeBody: function (body) { return withSourceID(__assign(__assign({}, body), { user: {
                        user_id: userID,
                        phone: phone,
                    } })); },
            }),
            payments: withAsync(apiPath(urls.payments), {
                mergeBody: function (body) { return withSourceID(__assign(__assign({}, body), { user_id: userID })); },
            }),
            zoneInfo: withAsync(apiPath(urls.zoneInfo), {
                mergeBody: function (body) { return withSourceID(__assign(__assign({}, body), { user: {
                        user_id: userID,
                        phone: phone,
                    } })); },
            }),
            draft: withAsync(apiPath(urls.draft), {
                mergeBody: function (body) { return withSourceID(__assign(__assign({}, body), { parks: [], id: userID, callcenter: {
                        // ...body?.callcenter,
                        key: sourceID,
                        phone: phone,
                    } })); },
            }),
            commit: withAsync(apiPath(urls.commit), {
                mergeBody: function (body) { return withSourceID(__assign(__assign({}, body), { userid: userID })); },
            }),
            suggest: withAsync(apiPath(urls.suggest), {
                mergeBody: function (body) { return withSourceID(__assign(__assign({}, body), { user: {
                        id: userID,
                        phone: phone,
                    } })); },
            }),
            couponActivate: withAsync(apiPath(urls.couponActivate), {
                mergeBody: function (body) { return withSourceID(__assign(__assign({}, body), { id: userID })); },
            }),
            couponDeactivate: withAsync(apiPath(urls.couponDeactivate), {
                mergeBody: function (body) { return withSourceID(__assign(__assign({}, body), { id: userID })); },
            }),
            couponList: withAsync(apiPath(urls.couponList), {
                mergeBody: function (body) { return withSourceID(__assign(__assign({}, body), { id: userID })); },
            }),
            localitySuggest: withAsync(apiPath(urls.localitySuggest)),
            historyList: withAsync(apiPath(urls.historyList)),
            historyItem: withAsync(apiPath(urls.historyItem)),
            receipts: withAsync(apiPath(urls.receipts), {
                method: app_1.AsyncMethod.GET
            }),
            preOrder: withAsync(apiPath(urls.preOrder)),
            search: withAsync(apiPath(urls.search)),
            cancel: withAsync(apiPath(urls.cancel)),
            // fixme never на всех ручках специально, чтобы знать что не покрыто типами
            tariffDescription: withAsync(apiPath(urls.tariffDescription)),
            changeDestinations: withAsync(apiPath(urls.changeDestinations)),
            /** @deprecated use suggest instead (action=pin_drop) */
            nearestZone: withAsync(apiPath(urls.nearestZone)),
            /** @deprecated use suggest instead */
            geoSearch: withAsync(apiPath(urls.geoSearch)),
            /** @deprecated use suggest instead (action=pin_drop, type=a|b) */
            nearestPosition: withAsync(apiPath(urls.nearestPosition)),
            /** @deprecated use suggest instead (action=zero_suggest, type=a) */
            expectedPositions: withAsync(apiPath(urls.expectedPositions)),
            /** @deprecated use suggest instead (action=zero_suggest, type=b) */
            expectedDestinations: withAsync(apiPath(urls.expectedDestinations)),
        };
        // profileRequest сразу вернет функцию отмены
        return profileRequest({
            onError: onError,
            onSuccess: function (response) {
                userID = response.user_id;
                onSuccess(api, response);
            },
        });
    };
};
exports.createCallCenterAPI = createCallCenterAPI;
